import { FC } from 'react'

import { Button } from 'ui/components/Buttons'
import { Link } from 'ui/components/Link'

import { DocumentActionsProps } from './DocumentActions.types'

export const DocumentActions: FC<DocumentActionsProps> = ({ editButtonParams }) => (
  <Link {...editButtonParams}>
    <Button face="tertiary">Edit</Button>
  </Link>
)
